import { differenceInYears, isBefore } from 'date-fns'

import { FeatureOptions } from '@wwt/entities/search-response'
import { TooltipIconType } from '@wwt/ui/components'

export const getTooltipIconType = (
	isCheckInFeature: boolean,
	selectedOption: FeatureOptions
): TooltipIconType => {
	const now = new Date()
	const expiredAt = selectedOption.expiredAt
		? new Date(selectedOption.expiredAt)
		: null
	const isExpired = expiredAt ? isBefore(expiredAt, now) : false
	const isExpiring = expiredAt ? differenceInYears(expiredAt, now) <= 1 : false

	if (selectedOption.isWarning) return TooltipIconType.WARNING
	if (isExpired) return TooltipIconType.EXPIRED
	if (isCheckInFeature) return TooltipIconType.DOLLAR
	if (isExpiring) return TooltipIconType.EXPIRING
	if (selectedOption.isFromReview) return TooltipIconType.SMILE
	if (selectedOption.isCustom) return TooltipIconType.CUSTOM

	return TooltipIconType.DEFAULT
}
